module.exports = __webpack_public_path__ + "static/media/sf-test-12.14521e8d.mp3";